module.exports = __webpack_public_path__ + "img/icone_chapeu_formatura.4bba6d3e.svg";